import { useParams } from "react-router-dom";
import { SharedInterfaceMonthlyReports } from "./sharedInterface";
import { useEffect } from "react";
import {
  monthlyMileageGapReportsListByUserAsync,
  planningMonthlyRowsAsync,
  selectMonthlyReportsListStatus,
  selectPlanningMonthlyRowsStatus,
} from "../fleetSlice";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { selectCompany, selectManager } from "../../homeSlice";

export type MonthlyReportsTabProps = {
  canGenerateReports: boolean;
  showMonthlyReportsTab: boolean;
};

export const MonthlyReportsTab = ({
  canGenerateReports,
  showMonthlyReportsTab,
}: MonthlyReportsTabProps) => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const manager = useAppSelector(selectManager);
  const monthlyReportsListStatus = useAppSelector(
    selectMonthlyReportsListStatus,
  );
  const planningMonthlyRowsStatus = useAppSelector(
    selectPlanningMonthlyRowsStatus,
  );

  useEffect(() => {
    if (
      company &&
      manager &&
      showMonthlyReportsTab &&
      monthlyReportsListStatus === "idle"
    ) {
      void dispatch(monthlyMileageGapReportsListByUserAsync(manager.uuid));
    }
  }, [
    dispatch,
    manager,
    monthlyReportsListStatus,
    company,
    showMonthlyReportsTab,
  ]);

  useEffect(() => {
    if (company && planningMonthlyRowsStatus === "idle") {
      void dispatch(planningMonthlyRowsAsync(company.uuid));
    }
  }, [company, dispatch, planningMonthlyRowsStatus]);

  if (params.tab !== "monthly_reports") {
    return;
  }

  return (
    <SharedInterfaceMonthlyReports canGenerateReports={canGenerateReports} />
  );
};
